import React from 'react';
import styled from 'styled-components';

import WP from 'WP';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import SmartLink from 'partials/SmartLink';
import Button from 'partials/Button';

const ActivityFeatures = props => {
    
    const { data } = props;

    return (
        <Wrapper>
            <Container grid>
                <Features 
                    colStart={1} 
                    colEnd={8}
                    rowStart={1}
                    rowEnd={2}
                    align="center"
                >
                    <li>{props.getDate(data.acf.from_date).toUpperCase()} - {props.getDate(data.acf.to_date).toUpperCase()}</li>
                    <span>•</span>
                    <li>{data.acf.duration} {WP.trans.hours.toUpperCase()}</li>
                    <span>•</span>
                    <li>{WP.trans.perPerson.toUpperCase()} {data.acf.price}</li>
                </Features>
                <GridElement 
                    colStart={1} 
                    colEnd={8} 
                    rowStart={2}
                    rowEnd={3}
                    colSpan
                >
                    <SmartLink to={props.getSlug(data.acf.travelize_id)}>
                        <StyledButton >{WP.trans.addToBooking}</StyledButton>
                    </SmartLink>
                </GridElement>
            </Container>
        </Wrapper>
    )
}

export default ActivityFeatures;

const Wrapper = styled.div`
`

const StyledButton = styled(Button)`
    width: 100%;
    padding: ${props => props.theme.spacing.contentS};
    margin-bottom: ${props => props.theme.spacing.elementL};
`

const Features = styled(GridElement)`
    display: flex;
    justify-content: space-evenly;
    padding-bottom: ${props => props.theme.spacing.contentL};

    li, span {
        list-style-type: none;
        font-size: 11px;
        line-height: 21px;
        font-weight: 600;
    }
`
